function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "inquiryTitle"
}, "inquiry");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-452.000000, -650.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Primary_Button_UI_Inquiry_Icon",
  transform: "translate(452.000000, 650.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-12",
  x: 0,
  y: 0,
  width: 80,
  height: 80
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.8720462,35.4545274 C29.7722738,35.4545274 32.1232277,37.7338317 32.1232277,40.545442 C32.1232277,42.3651386 31.137791,43.9609367 29.6565377,44.8611122 C32.6295466,45.9516879 34.7440924,48.7358073 34.7440924,52 L34.7440924,52 L19,52 C19,48.7358073 21.1146508,45.9516879 24.0876597,44.8611122 C22.6065115,43.9609367 21.6208647,42.3651386 21.6208647,40.545442 C21.6208647,37.7338317 23.9719237,35.4545274 26.8720462,35.4545274 Z M53.1279538,35.4545274 C56.0281813,35.4545274 58.3791353,37.7338317 58.3791353,40.545442 C58.3791353,42.3651386 57.3936986,43.9609367 55.9124453,44.8611122 C58.8854542,45.9516879 61,48.7358073 61,52 L61,52 L45.2559076,52 C45.2559076,48.7358073 47.3705584,45.9516879 50.3435673,44.8611122 C48.862419,43.9609367 47.8767723,42.3651386 47.8767723,40.545442 C47.8767723,37.7338317 50.2278313,35.4545274 53.1279538,35.4545274 Z M40.0000315,35.454558 C42.900154,35.454558 45.251213,37.7338623 45.251213,40.5454726 C45.251213,43.3570829 42.900154,45.6363872 40.0000315,45.6363872 C37.099909,45.6363872 34.74885,43.3570829 34.74885,40.5454726 C34.74885,37.7338623 37.099909,35.454558 40.0000315,35.454558 Z M33.4359496,24 C36.3360721,24 38.6871311,26.2793043 38.6871311,29.0909146 C38.6871311,31.902525 36.3360721,34.1818293 33.4359496,34.1818293 C30.5358271,34.1818293 28.1847681,31.902525 28.1847681,29.0909146 C28.1847681,26.2793043 30.5358271,24 33.4359496,24 Z M46.5639034,24 C49.4640259,24 51.8150849,26.2793043 51.8150849,29.0909146 C51.8150849,31.902525 49.4640259,34.1818293 46.5639034,34.1818293 C43.6637809,34.1818293 41.3127219,31.902525 41.3127219,29.0909146 C41.3127219,26.2793043 43.6637809,24 46.5639034,24 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}))));

var SvgPrimaryButtonUiInquiryIcon = function SvgPrimaryButtonUiInquiryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    "aria-labelledby": "inquiryTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "inquiryTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiInquiryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-inquiry-icon.6a9afb8f.svg";
export { ForwardRef as ReactComponent };